import { isValid } from 'date-fns';

export const normalizeDate = (dateInput: any, isUTC = false): Date | null => {
  if (!dateInput) {
    return null;
  }
  if (dateInput instanceof Date) {
    return isValid(dateInput) ? dateInput : null;
  }

  if (
    typeof dateInput === 'string' &&
    dateInput.includes('.') &&
    dateInput.includes(',')
  ) {
    // Parse the date string
    const [datePart, timePart] = dateInput.split(', ');
    const [day, month, year] = datePart.split('.').map(Number);
    const [hours, minutes, seconds] = timePart.split(':').map(Number);

    if (isUTC) {
      return new Date(Date.UTC(year, month - 1, day, hours, minutes, seconds));
    }
    return new Date(year, month - 1, day, hours, minutes, seconds);
  }

  // Handle numeric timestamp strings
  if (typeof dateInput === 'string' && /^\d+$/.test(dateInput)) {
    const timestamp = parseInt(dateInput, 10);
    const date = new Date(timestamp);
    return !isNaN(date.getTime()) ? date : null;
  }

  const date = new Date(dateInput);
  return !isNaN(date.getTime()) ? date : null;
};

export const getDateDifference = (startDate: any, endDate: any) => {
  const start = normalizeDate(startDate, true);
  const end = normalizeDate(endDate, true);
  if (!start || !end) {
    return null;
  }

  const totalSeconds = Math.abs(
    Math.floor((end.getTime() - start.getTime()) / 1000)
  );
  const d = Math.floor(totalSeconds / 86400);
  const h = Math.floor((totalSeconds % 86400) / 3600);
  const m = Math.floor((totalSeconds % 3600) / 60);
  const s = totalSeconds % 60;

  return [
    d && `${d}d`,
    h && `${h}h`,
    m && `${m}m`,
    (s || (!d && !h && !m)) && `${s}s`,
  ]
    .filter(Boolean)
    .join(' ');
};
